import { ICategory } from "@eventr/common";
import { CEventrIcons, ColoursObj, Icon, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useMemo } from "react";
import { getCategoryColours } from "utils";
import useDerivedScreenType from "v2/hooks/useDerivedScreenType";
import { useFormatValue } from "../../hooks/useFormatValue";
import { isPastDate, isSameDay } from "../card-utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { DisplayLabel } from "../subComponents/displayLabel";

interface ITrasportHeaderProps {
  transport_alias: string;
  label: string;
  labelTime?: string;
  checkInTime?: string;
  pick_up?: string;
  drop_off?: string;
  transport_type?: string;
  visibility: string;
  category?: ICategory | undefined;
  date?: string | undefined;
}

export const TransportHeader = ({
  transport_alias,
  label,
  labelTime,
  checkInTime,
  pick_up,
  drop_off,
  transport_type,
  visibility,
  category,
  date,
}: ITrasportHeaderProps) => {
  const { past } = useObjectContext();
  const screenType = useDerivedScreenType();
  const { formatValue } = useFormatValue();

  const labelOverride = useMemo(() => {
    if (date) {
      if (pick_up && isSameDay(date, pick_up)) {
        if (checkInTime && !isPastDate(checkInTime ?? "")) {
          return `${i18n.t("cards.checkIn")} ${formatValue(checkInTime, "time")}`;
        } else return `${i18n.t("cards.pick-up")} ${formatValue(pick_up, "time")}`;
      }

      if (drop_off && isSameDay(date, drop_off)) {
        return `${i18n.t("cards.drop-off")} ${formatValue(drop_off, "time")}`;
      }
      return undefined;
    }
    return undefined;
  }, [date, checkInTime, pick_up, drop_off, formatValue]);

  const transportIcon = CEventrIcons.includes(transport_type as TEventrIcons)
    ? (transport_type as TEventrIcons)
    : "Bus";
  //icon names comes from trasnportType
  const iconColour = getCategoryColours(past, category);
  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={(category?.icon as TEventrIcons) ?? transportIcon} iconColour={iconColour} />
        <CardText variant="bodyBold">{transport_alias}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <Icon
            height="16px"
            width="16px"
            name="Private"
            iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary}
          />
        ) : (
          visibility?.toLowerCase() === "public" && (
            <Icon
              height="16px"
              width="16px"
              name="Public"
              iconColour={past ? ColoursObj.shades.shade2 : ColoursObj.core.secondary}
            />
          )
        )}
        {screenType === "upNext" || screenType === "team" ? (
          (label && labelTime) || labelOverride ? (
            <DisplayLabel label={label} overrideLabel={labelOverride} labelTime={labelTime} />
          ) : (
            <DisplayLabel label="allDaySession" />
          )
        ) : (
          <CardText variant="bodyBold">{formatValue(pick_up ?? "", "date")}</CardText>
        )}
      </Stack>
    </Stack>
  );
};
